export const countryHasMedicalNumber = (country = '') =>
    ['DEU', 'AUT', 'GBR', 'CHE'].includes(country);
